export const REQUIRED = 'form.required';
export const REQUIRED_FIELD = 'form.requiredField';
export const LATITUDE = 'form.latitude';
export const LONGITUDE = 'form.longitude';
export const LIST = 'form.list';
export const LOGIN_REQUIRED = 'authent.required.login';
export const PASSWORD_REQUIRED = 'authent.required.password';
export const MIN = 'form.min';
export const MAX = 'form.max';
export const MIN_FIELD = 'form.minField';
export const MAX_FIELD = 'form.maxField';
export const END = 'form.endDate';
export const BETWEEN = 'form.between';
export const EMAIL = 'form.email';
export const INTEGER = 'form.integer';
export const NUMBER = 'form.number';
export const UNIQUE = 'form.unique';
export const POSITIVE = 'form.positiveValue';
export const ELEMENT_IN_LIST = 'form.elementInList';
